import React from 'react';

import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

const FormatNumber = (props) => {
    const { value, type } = props;
    let tiposeleccionado = null;

    switch (type) {
        case 'money':
            tiposeleccionado = (
                <NumberFormat fixedDecimalScale decimalScale={2} value={value} displayType="text" thousandSeparator prefix="$" />
            );
            break;
        case 'percent':
            tiposeleccionado = (
                <NumberFormat fixedDecimalScale decimalScale={2} value={value} displayType="text" thousandSeparator suffix="%" />
            );
            break;
        default:
            tiposeleccionado = <NumberFormat fixedDecimalScale decimalScale={2} value={value} displayType="text" thousandSeparator />;
    }
    return tiposeleccionado;
};

FormatNumber.propTypes = {
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};
export default FormatNumber;
